<template>
  <div class="instruction alert alert-secondary">
    <h5>{{header}}</h5>
    <p>{{isExpanded && text ? text : shortText}}</p>
    <a v-if="isCanExpanded" class="link" :class="{expanded : isExpanded}" @click="toggle()">{{(isExpanded ? 'instruction.collapse' : 'instruction.expand') |
      trans}}</a>
  </div>
</template>

<script>
  export default {
    props: {
      'text': {
        required: true,
        type: String,
      },
      'header': {
        required: true,
        type: String,
      },
      'shortTextLength': {
        type: Number,
        default: 300,
      },
    },
    data() {
      return {
        isExpanded: false,
      };
    },
    computed: {
      isCanExpanded() {
        return this.text && this.text.length > this.shortTextLength;
      },
      shortText: function () {
        if (this.isCanExpanded) {
          return this.text.substr(0, this.shortTextLength) + '...';
        }
        else {
          return this.text;
        }
      },
    },
    methods: {
      toggle: function () {
        this.isExpanded = !this.isExpanded;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/common/instruction/components/InstructionView.vue